import React, { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as Styles from './Styles';
import Banner from './banner/Banner';
import Faq from './faq/Faq';

type State = {};

class FaqViewComponent extends Component<PropsFromRedux, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Banner />
				<Faq />
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const FaqView = connector(FaqViewComponent);
export default FaqView;
